// Import React and necessary Material-UI components
import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";

// FinalCTA component to display a final call-to-action section
const FinalCTA = () => {
  return (
    // Main container for the FinalCTA section
    <Box
      sx={{
        backgroundColor: "#111111",
        color: "#fff",
        textAlign: "center",
        py: { xs: 6, sm: 8, md: 8 },
        px: { xs: 2, sm: 4, md: 6 },
      }}
    >
      {/* Section heading */}
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          mb: 2,
          fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.8rem" },
          lineHeight: 1.3,
        }}
      >
        There’s No “Perfect Time” — Just the Right System
      </Typography>

      {/* First description paragraph */}
      <Typography
        variant="body1"
        sx={{
          color: "#fff",
          maxWidth: "700px",
          mx: "auto",
          mb: 2,
          fontSize: { xs: "1rem", sm: "1.1rem" },
        }}
      >
        You don’t need a new life. Just a better structure.
      </Typography>

      {/* Second description paragraph */}
      <Typography
        variant="body1"
        sx={{
          color: "#fff",
          maxWidth: "680px",
          mx: "auto",
          mb: 4,
          fontSize: { xs: "1rem", sm: "1.1rem" },
        }}
      >
        Recomp Plus gives you the tools, feedback, and accountability to take
        control and keep it.
      </Typography>

      {/* Stack for call-to-action buttons */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        {/* Primary call-to-action button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#00ffff",
            color: "#000",
            fontWeight: 700,
            px: 4,
            py: 1.5,
            borderRadius: "25px",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            boxShadow: "0 4px 12px rgba(0, 248, 255, 0.3)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(0, 198, 194, 0.3)",
            },
          }}
          onClick={() => {
            const section = document.getElementById("subscription-section");
            if (section) {
              section.scrollIntoView({ behavior: "smooth" });
            }
          }}
        >
          Start Recomp Now
        </Button>

        {/* Secondary call-to-action button */}
        <Button
          variant="outlined"
          sx={{
            color: "#fff",
            borderColor: "#00ffff",
            fontWeight: 700,
            px: 4,
            py: 1.5,
            borderRadius: "25px",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            "&:hover": {
              color: "#000",
              backgroundColor: "#00ffff",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(0, 198, 194, 0.3)",
            },
          }}
        >
          Preview the Blueprint
        </Button>
      </Stack>
    </Box>
  );
};

// Export the FinalCTA component
export default FinalCTA;
